import { Command, HttpMethod } from "~/extensions/api";
import { HasonInfo } from "~/api/data/HasonInfo";
import { myPageStore } from "~/store/MyPageStore";
export class UpdateKaiyaku extends Command {
    constructor() {
        super(HttpMethod.Post, "kaiyaku/update");
    }
    //解約通知
    renrakuPostCode = "";
    renrakuAdr1 = "";
    renrakuAdr2 = "";
    renrakuAdr3 = "";
    taikyoKaiyakuStatus = -1;
    keyReturnYmd = null;
    henkinBankCd = null;
    henkinBansCd = null;
    henkinBankName = "";
    henkinBansName = "";
    henkinKouzaSb = -1;
    henkinKouzaNo = "";
    henkinKouzaName = "";
    henkinKouzaKana = "";
    taikyotachiaiKb = null;
    taikyotachiaiName = "";
    keyReturnNameKb = -1;
    keyReturnYoteiNum = null;
    nyukyokeiyakuNo = -1;
    orgNyukyokeiyakuNo = -1;
    taikyoNo = -1;
    //破損汚損
    hasonInfo = new HasonInfo();
    isKouzaChange = false;
    static create(taikyo, hason, isKouzaChange) {
        let command = new UpdateKaiyaku();
        // 解約返信のステータス
        let tsuchiStatus = 3;
        //解約通知
        command.renrakuPostCode = taikyo.postCode;
        command.renrakuAdr1 = taikyo.adr1;
        command.renrakuAdr2 = taikyo.adr2;
        command.renrakuAdr3 = taikyo.adr3;
        command.taikyoKaiyakuStatus = tsuchiStatus;
        command.keyReturnYmd = taikyo.keyReturnYmd;
        command.henkinBankCd = taikyo.henkinBankCd;
        command.henkinBansCd = taikyo.henkinBansCd;
        command.henkinBankName = taikyo.henkinBankName;
        command.henkinBansName = taikyo.henkinBansName;
        command.henkinKouzaSb = taikyo.henkinKouzaSb;
        command.henkinKouzaNo = taikyo.henkinKouzaNo;
        command.henkinKouzaKana = taikyo.henkinKouzaKana;
        command.henkinKouzaName = taikyo.henkinKouzaName;
        command.taikyotachiaiName = taikyo.taikyoTachiaiName;
        command.keyReturnYoteiNum = taikyo.numberOfReturnKeys;
        command.taikyotachiaiKb = taikyo.taikyoTachiaiKb;
        command.keyReturnNameKb = taikyo.keyReturnNameKb ?? 0;
        command.nyukyokeiyakuNo = myPageStore.selectedNyukyokeiyaku.nyukyokeiyakuNo;
        command.orgNyukyokeiyakuNo = myPageStore.selectedNyukyokeiyaku.orgNyukyokeiyakuNo;
        command.taikyoNo = myPageStore.selectedNyukyokeiyaku.orgNyukyokeiyakuNo;
        //破損汚損
        command.hasonInfo = hason;
        command.isKouzaChange = isKouzaChange;
        return command;
    }
}
